import { TFunction } from 'i18next';
import { IAiBotSettings } from '@/models/aiBotSettings.model';
import { AiBotConfigFormFields } from './types';

export const getAiBotConfigInitialValues = (settings?: IAiBotSettings | null, t?: TFunction) => ({
  [AiBotConfigFormFields.SENDER_NAME]: settings?.senderName ?? undefined,
  [AiBotConfigFormFields.MAIN_COLOR]: settings?.mainColor ?? undefined,
  [AiBotConfigFormFields.WELCOME_MESSAGE]: settings?.welcomeMessage ?? t?.('text_ai_bot_default_welcome_message'),
  [AiBotConfigFormFields.DISCLAIMER_MESSAGE]:
    settings?.disclaimerMessage ?? t?.('text_ai_bot_default_disclaimer_message'),
});
